<div class="image-container" *ngIf="!isMultipleImages">
  <img [src]="data.imageUrl" alt="Preview Image" class="preview-image" />
</div>

<div class="image-list" *ngIf="isMultipleImages">
  <div *ngFor="let image of data.imageUrl">
    <img [src]="image" alt="Preview Image" class="preview-image" />
  </div>
</div>
